import React from 'react';
import { Users, Sparkles, Target, TrendingUp, Dumbbell, Trophy } from 'lucide-react';
import { Card } from './ui/card';

const Services = () => {
  const services = [
    {
      icon: Users,
      title: 'Private Lessons',
      description: 'One-on-one personalized coaching tailored to your skill level and goals, from beginners to advanced competitive skaters.',
      features: ['Individual attention', 'Customized training plans', 'Flexible scheduling']
    },
    {
      icon: Sparkles,
      title: 'Choreography',
      description: 'Creative and expressive program choreography that showcases your unique strengths and musicality.',
      features: ['Original programs', 'Music selection', 'Artistic development']
    },
    {
      icon: Target,
      title: 'Technique Development',
      description: 'Master fundamental and advanced skating techniques with focused training on edges, turns, and footwork.',
      features: ['Edge work', 'Footwork sequences', 'Technical precision']
    },
    {
      icon: TrendingUp,
      title: 'Jump Development',
      description: 'Systematic jump training from single jumps to advanced multi-rotation jumps with proper technique and safety.',
      features: ['Progressive training', 'Jump mechanics', 'Rotation technique']
    },
    {
      icon: Trophy,
      title: 'Competition Preparation',
      description: 'Comprehensive competition readiness including program run-throughs, mental preparation, and performance coaching.',
      features: ['Program polishing', 'Performance skills', 'Competition strategy']
    },
    {
      icon: Dumbbell,
      title: 'Off-Ice Training',
      description: 'Supplementary off-ice conditioning to build strength, flexibility, and stamina essential for on-ice performance.',
      features: ['Strength training', 'Flexibility work', 'Conditioning']
    }
  ];

  return (
    <section id="services" className="py-24 bg-slate-900">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-sky-600 text-white rounded-full text-sm font-semibold mb-6">
            Coaching & Services
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Comprehensive Training Programs
          </h2>
          <p className="text-xl text-slate-300">
            Expert coaching services designed to elevate your skating from foundational skills to championship-level performance.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card
                key={index}
                className="p-8 bg-slate-800 border-slate-700 hover:border-sky-400 hover:shadow-xl transition-all duration-300 group"
              >
                <div className="bg-sky-600 w-14 h-14 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-7 h-7 text-white" />
                </div>
                
                <h3 className="text-2xl font-bold text-white mb-4">
                  {service.title}
                </h3>
                
                <p className="text-slate-300 mb-6 leading-relaxed">
                  {service.description}
                </p>
                
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-slate-300">
                      <div className="w-1.5 h-1.5 bg-sky-400 rounded-full mr-3"></div>
                      <span className="text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </Card>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="text-slate-300 mb-6 text-lg">
            Ready to elevate your skating? Let's discuss your goals and create a personalized training plan.
          </p>
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center px-8 py-4 bg-sky-600 hover:bg-sky-700 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
          >
            Get Started Today
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;